import React, { useMemo } from "react";
var ReadMore = function (_a) {
    var text = _a.text, maxLength = _a.maxLength, isExpanded = _a.isExpanded, setIsExpanded = _a.setIsExpanded;
    var toggleReadMore = function () {
        setIsExpanded(!isExpanded);
    };
    var truncatedText = useMemo(function () {
        return text.length > maxLength ? text.slice(0, maxLength) : text;
    }, [text, maxLength]);
    return (React.createElement("div", { className: "RobotoR_14_400 txt-midnight-blue-shade2 ".concat(isExpanded ? "w-100" : "w-140 text-end", " ").concat(text ? "d-block" : "d-none") },
        isExpanded ? text : truncatedText,
        "   ",
        text.length > maxLength && (React.createElement("span", { onClick: toggleReadMore, style: { right: !isExpanded && "24px" }, className: "RobotoR_14_400 txt-han-blue cursor-pointer text-decoration-underline text-nowrap ms-1" }, isExpanded ? "Read Less" : "Read More"))));
};
export default ReadMore;
